
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'TabBar',
  props: {
    tabs: {
      type: Array as PropType<string[]>,
      default: () => ['最新信号', '历史信号']
    },
    activeTab: {
      type: Number,
      default: 0
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  emits: ['update:activeTab'],
  setup(props, { emit }) {
    const handleTabClick = (index: number) => {
      emit('update:activeTab', index)
    }

    return {
      handleTabClick
    }
  }
})
